import React from "react";
import icons from "./icons";
import artifactIcons from "./kanaiArtifactIcons";
import { previewDocForArtifact } from "./saveAnswerHelpers";

/* ================================================================
   LF-5: knappen "Spara i projektet" (bredvid "Kopiera") och raden
   "Sparat i projektets dokument: <titel>" under ett sparat svar.
   Stilarna (kanai-save-*) ligger i SaveAnswerModal, som alltid är
   monterad i KanaiMessages.
   ================================================================ */

/* Inaktiv (aria-disabled, inte disabled) så att title-texten
   "Välj projekt först" visas som tooltip i alla webbläsare. */
export function SaveAnswerButton({ projectId, onClick }) {
  /* Alltid aktiv: saknas projektkontext (KanAI-modulen har ingen) väljer
     användaren projekt i modalen. */
  return (
    <button
      type="button"
      className="kai-msg-action-btn kanai-save-btn"
      title={projectId ? "Spara svaret som dokument i projektet" : "Spara svaret som dokument i ett projekt du väljer"}
      onClick={onClick}
    >
      {artifactIcons.filePlus} Spara i projektet
    </button>
  );
}

export function SavedArtifactRow({ artifact, onOpen }) {
  if (!artifact) return null;
  const doc = previewDocForArtifact(artifact);
  return (
    <div className="kanai-save-saved">
      {icons.file}
      <span>Sparat i projektets dokument:</span>
      {doc ? (
        <button
          type="button"
          className="kanai-save-saved-link"
          onClick={() => onOpen?.(doc)}
          title="Öppna det sparade dokumentet"
        >
          {artifact.title}
        </button>
      ) : (
        <strong>{artifact.title}</strong>
      )}
    </div>
  );
}
